export default {
    crumb: '',
    contacto: false,
};
